
import config from '../config';
import axios from 'axios';

const serverURL = process.env.REACT_APP_AIS_HOST_URL;

const headers = {
  'Access-Control-Allow-Origin': '*',
}
export const sendContactUsEmail = ({
  email,
  message,
  queryType,
  lookingFor,
  onDates,
  address,
  origin,
  subject,
}) => {
  return axios.post(`${serverURL}/api/events/sendContactUsEmail`, {
    email,
    message,
    queryType,
    lookingFor,
    onDates,
    address,
    origin,
    subject,
    canonicalRootURL: config.canonicalRootURL,
  }, {
    headers
  });
}

export const sendSearchNilEmail = ({ email, lookingFor, onDates, address, origin }) => {
  return axios.post(`${serverURL}/api/events/sendSearchNilEmail`, {
    email, lookingFor, onDates, address, origin,
    canonicalRootURL: config.canonicalRootURL,
  }, {
    headers
  });
}

export const sendLogConfirmationOfAoT = ({ email, page }) => {
  return axios.post(`${serverURL}/api/events/sendLogConfirmationOfAoT`, {
    email,
    page,
    canonicalRootURL: config.canonicalRootURL,
  }, {
    headers
  });
}

export const sendDisputeNotificationToAdmin = transactionId => {
  axios.post(`${serverURL}/api/events/sendDisputeNotificationToAdmin`, {
    transactionId,
  });
};

export const sendListingClosedNotificationToAdmin = listingId => {
  axios.post(`${serverURL}/api/events/sendListingClosedNotificationToAdmin`, {
    listingId,
  });
};